import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { AddPostLikePayload } from '@web/newsfeed/types/apiTypes';
import { useNewsfeedBridge } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';

type OnAddLikeMutate = (articleId: ID) => void;

export const useAddArticleLike = (onAddLikeMutate: OnAddLikeMutate) => {
  const { newsfeed } = useSlingApi();
  const newsfeedBridge = useNewsfeedBridge();

  const mutation = useMutation({
    mutationFn: async ({ pageId, articleId }: AddPostLikePayload) => {
      const result = await newsfeed.addLike(pageId, articleId);
      return result.data;
    },
    onMutate: (payload) => {
      onAddLikeMutate(payload.articleId);
    },
    onSuccess: (payload) => {
      newsfeedBridge.onAddArticleLike(payload);
    },
  });

  return mutation;
};
